// INVARIANT: Analytics are fire-and-forget observers — no behavioral dependency (see docs/invariants/PHASE_3_INVARIANTS.md)
import posthog from "posthog-js";
import { BUILD_TIME } from './version';

export const initAnalytics = () => {
  if (typeof window !== "undefined" && import.meta.env.PROD) {
    posthog.init("phc_IPzLgVklcUXg5f9Hc7Kqkn67BLYaf4YnefaWdKLW2XV", {
      api_host: "https://app.posthog.com",
      loaded: (posthog) => {
        if (import.meta.env.DEV) {
          posthog.opt_out_capturing();
        }
      },
    });
  }
};

export const trackEvent = (eventName: string, properties?: Record<string, any>) => {
  if (import.meta.env.PROD) {
    posthog.capture(eventName, properties);
  } else {
    console.log("[Analytics] Event:", eventName, properties);
  }
};

export const identifyUser = (userId: string, properties?: Record<string, any>) => {
  if (import.meta.env.PROD) {
    posthog.identify(userId, {
      ...properties,
      app_build_time: BUILD_TIME,
    });
  } else {
    console.log("[Analytics] Identify:", userId, properties);
  }
};
